<!--
<section class="timeline">
    <ol>
      <li>
        <div>
          <time>1934</time> At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium
        </div>
      </li>
      <li>
        <div>
          <time>1937</time> Proin quam velit, efficitur vel neque vitae, rhoncus commodo mi. Suspendisse finibus mauris et bibendum molestie. Aenean ex augue, varius et pulvinar in, pretium non nisi.
        </div>
      </li>
      <li>
        <div>
          <time>1940</time> Proin iaculis, nibh eget efficitur varius, libero tellus porta dolor, at pulvinar tortor ex eget ligula. Integer eu dapibus arcu, sit amet sollicitudin eros.
        </div>
      </li>
      <li>
        <div>
          <time>1943</time> In mattis elit vitae odio posuere, nec maximus massa varius. Suspendisse varius volutpat mattis. Vestibulum id magna est.
        </div>
      </li>

      <li></li>
    </ol>

    </section>
   -->

<ul class="timeline">
  <li class="direction-r">
    <div class="arrow-wrapper">
      <div class="flag-wrapper">
        <span class="flag">Registration Period</span>
      </div>
    </div>
    <span class="time-wrapper">16th Aug - 29th Sep</span>
    <div class="desc">
      Eureka! opens its applications for all entrepreneurs on 16th August.
      Register by filling your details and logging in to the Eureka! dashboard.
      Add your co-founders and fill your startup idea details.
    </div>
  </li>
  <li class="direction-l">
    <div class="arrow-wrapper">
      <div class="flag-wrapper">
        <span class="flag">Zonals Round</span>
      </div>
    </div>
    <span class="time-wrapper">5th Oct - 4th Nov</span>
    <div class="desc">
      Get assigned dedicated mentors for exclusive one-on-one sessions. Our
      expert mentors will guide you in developing your business model using
      proven startup methods.
    </div>
  </li>
  <li class="direction-r">
    <div class="arrow-wrapper">
      <div class="flag-wrapper">
        <span class="flag">Semi-Finals</span>
      </div>
    </div>
    <span class="time-wrapper">14th Nov - 4th Dec</span>
    <div class="desc">
      Semi-Finalists are now declared based on the evaluation in the zonals. The
      startups now will receive guidance in building a Business Model for their
      startup.
    </div>
  </li>
  <li class="direction-l">
    <div class="arrow-wrapper">
      <div class="flag-wrapper">
        <span class="flag">Grand Finale</span>
      </div>
    </div>
    <span class="time-wrapper">E-Summit</span>
    <div class="desc">
      Finalists are now declared based on the evaluation in the semifinals. The
      startups now will be invited to IIT Bombay where in they will attend Grand
      Finale of Asia's largest business model competition
    </div>
  </li>
</ul>
